import * as React from 'react';
import { TooltipHost, MaskedTextField, getTheme } from '@fluentui/react';
import { validateRulesFieldValue } from 'components/util/validation';
import { ValidationMessage } from '../admin/rules/ValidationMessage';
import { settingsFieldStyles } from '../admin/SettingsStyles';
import { TooltipText } from '../shared';

interface ConfigFieldProps {
  onChange: (number) => void;
  value: number;
  tooltip?: string;
}

export const PercentageFieldGeneric: React.FC<ConfigFieldProps> = props => {
  const { palette, fonts } = getTheme();

  const [showError, setError] = React.useState<boolean>(false);
  const [value, setValue] = React.useState<string>(((props.value || 0) * 100)?.toString());

  const onComponentChange = (event): void => {
    let tmpValue: string = event.target.value.split('%')[0];
    tmpValue = tmpValue.replace(/ /g, '');
    if (tmpValue !== '0' && tmpValue !== '00' && tmpValue !== '') {
      tmpValue = String(validateRulesFieldValue(tmpValue, 1, 99));
      setError(false);
    } else {
      tmpValue = '0';
      setError(true);
    }
    props.onChange(Number(tmpValue) / 100);
    setValue(tmpValue);
  };

  const maskFormat: { [key: string]: RegExp } = {
    '*': /[0-9]/
  };

  return (
    <TooltipHost content={props.tooltip}>
      <MaskedTextField
        label={'Percentage'}
        value={value}
        onChange={(e): void => onComponentChange(e)}
        mask="**%"
        maskFormat={maskFormat}
        maskChar=" "
        styles={settingsFieldStyles(palette, fonts, 60)}
      />
      {showError && <ValidationMessage message={TooltipText.validationPercentageMessage} fonts={fonts} />}
    </TooltipHost>
  );
};
